
import { computed, defineComponent, reactive } from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import { useTelaBase } from '@/core/composables/TelaBase';
import ServicoCenarioFiscal from '@/servicos/Cadastros/Tributacoes/ServicoCenarioFiscal';

export default defineComponent({
  name: 'SelecionarCstCofins',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: String || undefined,
    },
    codigosSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filtrarApenasCstEntradas: {
      type: Boolean,
      default: false,
    },
    filtrarApenasCstSaidas: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaItemGenericoTexto } = useTelaBase();

    const state = reactive({
      // listaCstCofinsSaidas: [] as IOptionString[],
      // listaCstCofinsEntradas: [] as IOptionString[],
      listaCstCofins: [] as IOptionString[],
    });

    (async () => {
      // const listaCstCofinsEntradas = await new ServicoCenarioFiscal().obterListaPisCofinsEntradas();
      // state.listaCstCofinsEntradas = montaOpcoesComListaItemGenericoTexto(listaCstCofinsEntradas);

      // const listaCstCofinsSaidas = await new ServicoCenarioFiscal().obterListaPisCofinsSaidas();
      // state.listaCstCofinsSaidas = montaOpcoesComListaItemGenericoTexto(listaCstCofinsSaidas);
      const listaCstCofins = await new ServicoCenarioFiscal().obterListaPisCofins();
      state.listaCstCofins = montaOpcoesComListaItemGenericoTexto(listaCstCofins);
    })();

    function obterCstCofins():any {
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterCstCofins(),
      set: (val: string) => {
        emit('update:codigoSelecionado', val);
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (val: string[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function change() {
      emit('change', props.varios ? props.codigosSelecionados : props.codigoSelecionado);
    }

    return {
      props,
      state,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      change,
    };
  },
});
